<template>
  <label class="order_history_locations_select select pointer relative select-wrapper">
    <base-select
      name="order_history_locations_select"
      id="order_history_locations_select"
      :options="correctLocations"
      :selected="locationCode"
      :placeholder="$t('City *')"
      v-model="locationCode"
      @change="switchLocation"
    >
    </base-select>
  </label>
</template>

<script>
import BaseSelect from "../Form/BaseSelect";
import { mapGetters, mapActions } from 'vuex'
export default {
  name: "OrderHistorySelectLocation",
  props: {
    locations: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      locationCode: ''
    }
  },
  components: {
    BaseSelect
  },
  mounted () {
    if (this.correctLocations.length > 0 && this.location) {
      this.correctLocations.map((location) => {
        if (this.location.code === location.value) {
          this.locationCode = this.location.code;
        } else {
          this.locationCode = this.locationByCode(this.locations[0]).code
          if (!this.orderHistory) {
            this.clearOrderHistory()
          }
        }
      })
    } else {
      if (this.location) {
        this.locationCode = this.location
      } else {
        this.locationCode = this.locationByCode(this.locations[0]).name
      }
    }
  },
  computed: {
    ...mapGetters({
      locationByCode: 'locations/getLocationByCode',
      location: 'locations/getActiveLocation',
      orderHistory: 'user/getOrdersHistory'
    }),
    correctLocations () {
      let correct = []
      if (this.locations && this.location) {
        this.locations.map(locationCode => {
          let locationByCode = this.locationByCode(locationCode);
          correct.push({
            value: locationByCode.code,
            label: locationByCode.name
          })
        })
      }
      return correct
    }
  },
  methods: {
    switchLocation () {
      this.$emit('switchLocation', this.locationCode);
      this.$forceUpdate();
    },
    ...mapActions({
      clearOrderHistory: 'user/clearOrderHistory',
      loadPartners: 'partners/loadPartners'
    })
  }
}
</script>

<style lang="scss" scoped>
  .select{
    padding-left: 10px;
    border-radius: 5px;
    border: solid 1px #e8e3e3;
    background-color: #ffffff;
    width: 20%;
    @media (max-width: 990px) {
      width: 30%;
    }
    @media (max-width: 700px) {
      display: block;
      width: 96%;
    }
  }
</style>
<style>
  .order_history_locations_select .select-wrapper select{
    padding-left: 5px;
    color: #000;
  }
  .order_history_locations_select .select-wrapper select:focus ~ label, .select-wrapper select:not(.empty) ~ label {
    top: 0;
    font-size: 12px;
    left: 0;
    color: #4dba87;
    display: none;
  }
  .order_history_locations_select .select-wrapper.relative:after{
    top: 1.2rem;
  }
</style>
